(async () => {

    const bind = async(el = false) => {
        const els =
            $('.dpl-ad');
        if (els.length > 0) {
            const f =
                await import('./scripts/Client.js');
            f.default(el);
        }
    };

    await bind();

    if( window.acf ) {
        window.acf.addAction(
            'render_block_preview',
            async(el, ev) => {
                if(
                    ev.name==='acf/ad300250' ||
                    ev.name==='acf/ad72890' ||
                    ev.name==='acf/ad400800-interscroller' ||
                    ev.name==='acf/ad-rich' ) {
                    bind(el);
                }
            });
    }
})();